import { axios } from '@Root/API'

export const getDynamicOptionByStudent = studyProgrammeId => {
  return axios.get(`dynamic-data-for-course-session/student/${studyProgrammeId}`)
}
